import { render } from "./inputField.vue?vue&type=template&id=28508a72"
import script from "./inputField.vue?vue&type=script&lang=js"
export * from "./inputField.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__